module.exports = __webpack_public_path__ + "Other-gray.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Other-gray.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Other-gray.png
// module chunks = 12